import { useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { RolePermission, useRoleDetail, useUpdateRole } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';
import { getErrorMessage } from '../apiHelper';

function EditRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList = [], loading } = useRoleDetail(roleId);
	const [updateRole, { loading: updating }] = useUpdateRole();
	const { setToastInfo } = useDashboardContext();
	const { t } = useTranslation();
	const initialValues = useMemo(() => {
		if (!role) {
			return undefined;
		}
		return {
			roleId: role.id,
			roleName: role.role,
			sourceRoleName: role.role,
			description: role.description,
			isPrimary: role.isPrimary,
			permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? [],
		};
	}, [role]);

	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await updateRole(role, values);
			setToastInfo?.({
  				message: t('notification.update.success', { name: 'Role' }),
				type: 'success',
				icon: 'check',
			});
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			const message = getErrorMessage(error, t("errorCodes.genericErrorMessage"));
			setToastInfo?.({
				message: message,
				type: 'warning',
				icon: 'campaignInfo',
			});
		}
	};

	if (loading || !role || !initialValues) return <Spin />
	return (
		<PermissionList		
			mode="edit"
			permissionList={permissionList}
			initialValues={initialValues}
			loading={updating}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default EditRole;
